import InvestmentMultiSelect from "./InvestmentMultiSelect";

export default InvestmentMultiSelect;